import * as React from "react";
import NavBar from "../components/NavBar";
import { Table, Button, ButtonToolbar, ButtonGroup, Modal } from "react-bootstrap";
import { LinkContainer, IndexLinkContainer } from "react-router-bootstrap";
import { RouteChildrenProps } from "react-router";
import AppUser from "../AppUser";
import firebase from "../firebase";
import "./DeviceMaintPage.css";

interface Props extends RouteChildrenProps {
    user: AppUser,
    onsubmit: (deviceState: string) => void
}

export default class DeviceMaintPage extends React.Component<Props, {}> {

    handleImport = async () => {
        this.props.onsubmit("Import");
    };

    handleList = async () => {
        this.props.onsubmit("List");
    };

    render() {
        return (
            <div>
                <NavBar {...this.props}/>
                <div className="device_main_btn">
                    <h2 className="device_main_title">機器情報メンテ</h2>
                    <ButtonToolbar>
                        <LinkContainer to="/device-maint">
                            <Button variant="primary" onClick={this.handleList}>機器リスト表示</Button>
                        </LinkContainer>
                        <LinkContainer to="/device-maint">
                            <Button variant="primary" onClick={this.handleImport}>機器リスト取込</Button>
                        </LinkContainer>
                    </ButtonToolbar>
                </div>
            </div>
        );
    }
}
